import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const depositSchema = z.object({
  /** 入金識別uuid */
  uuid: z.string(),
  /** 入金address */
  address: z.string().optional(),
  /** アセット名 */
  asset: z.string(),
  /** ネットワーク名 */
  network: z.string().optional(),
  /** 入金数量 */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** 入金トランザクションID(暗号資産の時のみ) */
  txid: z.string().nullable().optional(),
  /** 入金状態: FOUND, CONFIRMED, DONE */
  status: z.union([
    z.literal('FOUND'),
    z.literal('CONFIRMED'),
    z.literal('DONE'),
  ]),
  /** 検知UNIXタイムスタンプ(ミリ秒) */
  found_at: z.number().int(),
  /** 承認(残高追加確定時)UNIXタイムスタンプ(ミリ秒、承認後のみ存在) */
  confirmed_at: z.number().int().nullable().optional(),
})

export type Deposit = z.infer<typeof depositSchema>
